module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/contacts_team-363048a67e4735dfea2c2909b8428aa6.svg";